/**
 * Sites resource — typed wrappers over `/v1/iot/sites` (org-scoped via
 * X-Org-Id). The onboarding wizard creates the org's first site before
 * claiming its first gateway.
 */

import { api } from "@/lib/api-client";
import type { Paginated } from "./types";

/** Mirrors iot.Site (platform-core/internal/iot/sites.go). */
export interface Site {
  id: string;
  org_id: string;
  slug: string;
  name: string;
  location_meta: unknown;
  created_at: string;
  updated_at: string;
}

export const sitesApi = {
  list: () => api.get<Paginated<Site>>("/v1/iot/sites"),
  create: (body: { slug: string; name: string }) =>
    api.post<Site>("/v1/iot/sites", body),
};
